module.exports = __webpack_public_path__ + "img/footer-qrcode-bili.a5674357.png";